"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePropsToSWRKey = void 0;
const swr_1 = __importStar(require("swr"));
const react_1 = require("react");
const useSocket_1 = __importDefault(require("../useSocket"));
const useCurrentRef_1 = require("../useCurrentRef");
const useDeepMemo_1 = require("../useDeepMemo");
const enhancedFetch_1 = require("../../lib/enhancedFetch");
const useArrayOrObject_1 = require("../useArrayOrObject");
function usePropsToSWRKey(props) {
    const onResponseRef = useCurrentRef_1.useCurrentRef(props.onResponse);
    const formatResponseRef = useCurrentRef_1.useCurrentRef(props.formatResponse);
    const isAllowed = props.isAllowed !== undefined ? props.isAllowed : true;
    const swrKey = useDeepMemo_1.useDeepMemo({
        url: props.url,
        body: props.body,
        method: props.method,
        onResponseRef,
        formatResponseRef,
    });
    const { cache } = swr_1.useSWRConfig();
    const serializedMapKey = swr_1.unstable_serialize(swrKey);
    let swrResponse = cache.get(serializedMapKey);
    if (props.initialData && !swrResponse) {
        cache.set(serializedMapKey, props.initialData);
        swrResponse = props.initialData;
    }
    /*
    * If we already have requested out, we will return the swrKey.
    * This allows us when isAllowed was previously set to true, and then now is set to false
    * it will still return the last response that was sent.
    */
    if (swrResponse) {
        return swrKey;
    }
    if (!isAllowed) {
        return null;
    }
    return swrKey;
}
exports.usePropsToSWRKey = usePropsToSWRKey;
function fetcher(props) {
    return enhancedFetch_1.enhancedFetch(props.url, Object.assign(Object.assign({}, props), { onResponse: props.onResponseRef.current, formatResponse: props.formatResponseRef.current }));
}
function getSWRStatus(props, data, error) {
    if (error) {
        return 'error';
    }
    const isAllowed = props.isAllowed !== undefined ? props.isAllowed : true;
    if (!isAllowed && !data) {
        return 'uninitiated';
    }
    if (!data) {
        return 'loading';
    }
    return 'completed';
}
function useFetch(props) {
    const swrKey = usePropsToSWRKey(props);
    const { data, error, mutate } = swr_1.default(swrKey, fetcher, Object.assign({ onError: (err) => console.error(err), fallbackData: props.initialData }, props.swrOptions));
    const setData = react_1.useCallback((action) => mutate(action instanceof Function ? action(data) : action, false), [data, mutate]);
    const refresh = react_1.useCallback(() => mutate(), [mutate]);
    const returnProps = useDeepMemo_1.useDeepMemo({
        error,
        data,
        setData,
        refresh,
        swrKey,
        isAllowed: props.isAllowed,
        status: getSWRStatus(props, data, error),
    });
    useSocket_1.default(props.socket);
    return useArrayOrObject_1.useArrayOrObject(data, setData, returnProps, returnProps);
}
exports.default = useFetch;
